/**
 * Il colore di un programma: un segno **del coach**, come le etichette
 * colorate del Finder, per riconoscere a colpo d'occhio nella libreria i
 * programmi di CrossFit, di pesistica, di Hyrox. Facoltativo (`null` =
 * nessuno), senza significato per l'app, invisibile all'atleta.
 *
 * Tavolozza chiusa, gemella di `PROGRAM_COLORS` in `backend/models/program.py`.
 * Le classi sono stringhe intere (Tailwind le trova solo cosi') e ogni colore
 * ha un nome tradotto (`programColorLabelKey`): il colore non viaggia mai da
 * solo (WCAG 1.4.1). Spec: docs/program-colors/01-analisi.md.
 */

export const PROGRAM_COLORS = [
	"red",
	"orange",
	"yellow",
	"green",
	"blue",
	"purple",
	"pink",
	"gray",
];

// Tinte 400 di Tailwind: leggibili sul fondo Obsidian e lontane dai colori di
// stato dell'app (volt, blaze, acid), cosi' un'etichetta non pare un avviso.
export const PROGRAM_COLOR_CLASSES = {
	red: { bg: "bg-red-400", ring: "ring-red-400" },
	orange: { bg: "bg-orange-400", ring: "ring-orange-400" },
	yellow: { bg: "bg-amber-400", ring: "ring-amber-400" },
	green: { bg: "bg-green-400", ring: "ring-green-400" },
	blue: { bg: "bg-sky-400", ring: "ring-sky-400" },
	purple: { bg: "bg-violet-400", ring: "ring-violet-400" },
	pink: { bg: "bg-pink-400", ring: "ring-pink-400" },
	gray: { bg: "bg-zinc-400", ring: "ring-zinc-400" },
};

/** Una chiave della tavolozza o `null`: tutto il resto (vecchi dati, typo) e' «nessun colore». */
export const normalizeProgramColor = (value) =>
	PROGRAM_COLORS.includes(value) ? value : null;

/** La chiave i18n del nome del colore (`programColorRed`, ...). */
export const programColorLabelKey = (color) =>
	`programColor${color.charAt(0).toUpperCase()}${color.slice(1)}`;

/** Il nome tradotto del colore di un programma, o `null` se non ne ha. */
export const programColorLabel = (program, t) => {
	const color = normalizeProgramColor(program?.color);
	return color ? t(programColorLabelKey(color)) : null;
};

/**
 * I colori in uso in un elenco, nell'ordine della tavolozza: il filtro della
 * libreria mostra solo quelli, e sparisce se nessun programma e' colorato.
 */
export const usedProgramColors = (programs) => {
	const used = new Set(
		(Array.isArray(programs) ? programs : [])
			.map((program) => normalizeProgramColor(program?.color))
			.filter(Boolean),
	);
	return PROGRAM_COLORS.filter((color) => used.has(color));
};
